//#region IMPORT
import React from 'react';
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { BusinessGridCommon } from '../../../../Components/BusinessGridCommon';
import { getColumnDefs1 } from './ACS_BASIC_01_ColumnDefs';
import FileUploadDialog from '../../../../Components/FileUploadDialog/FileUploadDialog';
import MemberInfoModal from '../../../../Components/MemberInfoModal/MemberInfoModal';
import GongjongSelectModal from '../../../../Components/GongjongSelectModal';
import { Typography } from '@mui/material';
import GridFunctions from '../../../../Services/agGrid/ag-Grid-functions';
import dayjs from 'dayjs';
//#endregion

function ACS_BASIC_01(props) {
  const columnDefs1 = getColumnDefs1(props);

  return (
    <React.Fragment>
      <BusinessGridCommon
        getRowId={(params) => String(params.data?.no ?? params.data?.id ?? params.rowIndex)}
        deleteYn1="Y"
        addYn1="Y"
        fileDownloadYn1="Y"
        fileDownloadClick1={() => {
          if (!props.validateSelection?.()) return;
          props.ExcelDownload1?.();
        }}
        autoHeaderHeight={true}
        stopEditingWhenCellsLoseFocus={false}
        gridRef={props.gridRef1}
        columnDefs={columnDefs1}
        rowData={props.rowData1}
        setSelectedRowData={props.setSelectedRowData1}
        setChangedRowData={props.setChangedRowData1}
        gridOptions={{ singleClickEdit: true }}
        onCellEditingStarted={(e) => {
          const api = props.gridRef1?.current?.api;
          if (!api) return;
          const key =
            (e.data && (e.data.accidentSeq ?? e.data.no ?? e.data.id)) ?? null;
          const updatedRow = {
            ...e.data,
            editYn: 'Y',
          };
          e.node?.setData?.(updatedRow);
          if (key != null) {
            props.setRowData1?.((prev) => {
              const list = prev || [];
              const existing = list.find(
                (r) => (r.accidentSeq ?? r.no ?? r.id) === key
              );
              if (!existing) return [updatedRow, ...list];
              return list.map((r) =>
                (r.accidentSeq ?? r.no ?? r.id) !== key
                  ? r
                  : { ...r, ...updatedRow }
              );
            });
          }
        }}
        onCellEditingStopped={() => {
          const api = props.gridRef1?.current?.api;
          // 편집 중이던 셀의 값을 확정(commit)한 뒤 포커스 제거
          api?.stopEditing?.();
          api?.clearFocusedCell?.();
        }}
        addClick1={() => {
          if (!props.validateSelection?.()) return;
          GridFunctions.addClick(props.gridRef1, props.setChangedRowData1, { skipStartEdit: true });
          const api = props.gridRef1?.current?.api;
          if (api) {
            const firstRowNode = api.getDisplayedRowAtIndex(0);
            if (firstRowNode?.data?.newYn === 'Y') {
              props.rowClickData.current = {
                rowIndex: firstRowNode.rowIndex,
                data: firstRowNode.data,
              };
            }
          }
          props.setModalToggle1?.(true);
        }}
        refreshClick1={() => {
          if (props.validateSelection?.()) props.SearchLogic1?.();
        }}
        deleteClick1={() => {
          if (!props.validateSelection?.()) return;
          const hasNew = props.selectedRowData1?.some((r) => r.newYn === 'Y');
          if (hasNew) props.NewYnErrorMsg?.();
          else props.MarkedForDeletion1?.(props.selectedRowData1);
        }}
        onCellValueChanged={(e) => {
          // F컴포넌트(ACS_BASIC_01F)와 동일한 키 규칙 사용: accidentSeq → no → id
          const key =
            (e.data && (e.data.accidentSeq ?? e.data.no ?? e.data.id)) ?? null;
          const field = e.column?.getColDef?.()?.field ?? e.colDef?.field;
          const newVal = e.newValue !== undefined ? e.newValue : (field ? e.data?.[field] : undefined);

          // 휴업(예상)일수 변경 시 복귀(예정)일자 자동 계산
          let computedReturnDate = null;
          if (field === 'leaveDays' || field === 'accidentDate') {
            const accidentDate = field === 'accidentDate' ? newVal : e.data?.accidentDate;
            const leaveDaysStr = field === 'leaveDays' ? newVal : e.data?.leaveDays;
            const days = parseInt(String(leaveDaysStr ?? '').trim(), 10);
            const hasDate = accidentDate != null && accidentDate !== '' && dayjs(accidentDate).isValid();
            if (hasDate && !isNaN(days) && days >= 0) {
              computedReturnDate = dayjs(accidentDate).startOf('day').add(days, 'day').format('YYYY-MM-DD');
            }
          }

          const updatedRow = {
            ...e.data,
            editYn: 'Y',
            ...(field != null && newVal !== undefined ? { [field]: newVal } : {}),
            ...(computedReturnDate != null ? { returnDate: computedReturnDate } : {}),
          };

          e.node?.setData?.(updatedRow);

          if (key != null) {
            props.setChangedRowData1?.((prev) => {
              const filtered = prev.filter(
                (r) => (r.accidentSeq ?? r.no ?? r.id) !== key
              );
              return [...filtered, updatedRow];
            });
          }
          props.setRowData1?.((prev) => {
            const list = prev || [];
            if (key == null) return [updatedRow, ...list];
            const existing = list.find(
              (r) => (r.accidentSeq ?? r.no ?? r.id) === key
            );
            if (!existing) return [updatedRow, ...list];
            return list.map((r) =>
              (r.accidentSeq ?? r.no ?? r.id) !== key ? r : { ...r, ...updatedRow }
            );
          });
        }}
        onCellClicked={(e) => {
          const gridApi = props.gridRef1?.current?.api;
          if (!gridApi) return;
          const isCheckboxClick = e.event?.target?.type === 'checkbox';
          const colField = e.column?.getColDef?.()?.field ?? e.colDef?.field;
          const isDateTimeCell = colField === 'accidentDate';
          if (!isCheckboxClick && !isDateTimeCell) {
            gridApi.ensureIndexVisible(e.rowIndex, 'middle');
            const copied = JSON.parse(JSON.stringify(e.data));
            props.handleRowSelection1?.(copied, e.rowIndex);
            gridApi.getDisplayedRowAtIndex(e.rowIndex)?.setSelected?.(true, false);
          }
        }}
        onSelectionChanged={() => {
          const gridApi = props.gridRef1?.current?.api;
          const selectedNodes = gridApi?.getSelectedNodes() ?? [];
          const selectedData = selectedNodes.map((n) => n.data).filter(Boolean);
          props.selectedRowNosRef1.current = new Set(selectedData.map((r) => r.no));
          props.setSelectedRowData1?.(selectedData);
        }}
      />
      {props.fileModalToggle && (
        <FileUploadDialog
          open={props.fileModalToggle}
          onClose={() => props.setFileModalToggle?.(false)}
          gridRef={props.gridRef1}
          selectedRowData={props.selectedRowData1}
          setSelectedRowData={props.setSelectedRowData1}
          setChangedRowData={props.setChangedRowData1}
          fileNameField={props.currentFileFieldType === 'investigationStatFile' ? 'investigationStatFileName' : 'reportFileName'}
          saveNameField={props.currentFileFieldType === 'investigationStatFile' ? 'investigationStatSaveName' : 'reportSaveName'}
          filePathField={props.currentFileFieldType === 'investigationStatFile' ? 'investigationStatFilePath' : 'reportFilePath'}
          SaveLogicPreview={props.SaveLogicPreview}
          DownloadLogic={props.DownloadLogic1}
        />
      )}
      <MemberInfoModal
        open={props.modalToggle1}
        onClose={() => props.setModalToggle1?.(false)}
        onSelection={props.HandleManageSelection}
        columnVariant="accidentStatus"
      />
      <GongjongSelectModal
        open={props.gongjongModalToggle}
        onClose={() => props.setGongjongModalToggle?.(false)}
        onSelect={props.HandleGongjongSelection}
        custCd={props.custCd}
        allowOtherOption
        subtitle="부서를 선택한 후 공정을 선택하세요. 목록에 없으면 하단 「기타 선택」을 이용해 주세요."
        otherOptionAlertDetail={
          <Typography variant="body2" component="span" sx={{ lineHeight: 1.6 }}>
            「기타 선택」을 하신 뒤에는 그리드의 <strong>재해발생형태</strong> 또는{' '}
            <strong>사고경위</strong> 칸에 구체적인 설명을 반드시 입력해 주세요.
          </Typography>
        }
      />
    </React.Fragment>
  );
}

export default ACS_BASIC_01;
